/* tslint:disable */
/* eslint-disable */
/**
 * KGH PROJECT API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CompanyBranchDto } from '../models';
// @ts-ignore
import { CompanyBranchDtoOrdinalPaginatedList } from '../models';
// @ts-ignore
import { CreateCompanyBranchRequest } from '../models';
// @ts-ignore
import { UpdateCompanyBranchCommand } from '../models';
/**
 * CompanyBranchesApi - axios parameter creator
 * @export
 */
export const CompanyBranchesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [municipalityId] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesGet: async (pageNumber?: number, pageSize?: number, search?: string, municipalityId?: string, entityId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/company-branches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (municipalityId !== undefined) {
                localVarQueryParameter['MunicipalityId'] = municipalityId;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['EntityId'] = entityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCompanyBranchesIdDelete', 'id', id)
            const localVarPath = `/api/company-branches/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCompanyBranchesIdGet', 'id', id)
            const localVarPath = `/api/company-branches/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCompanyBranchCommand} [updateCompanyBranchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesIdPut: async (id: string, updateCompanyBranchCommand?: UpdateCompanyBranchCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCompanyBranchesIdPut', 'id', id)
            const localVarPath = `/api/company-branches/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCompanyBranchCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCompanyBranchRequest} [createCompanyBranchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesPost: async (createCompanyBranchRequest?: CreateCompanyBranchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/company-branches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyBranchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyBranchesApi - functional programming interface
 * @export
 */
export const CompanyBranchesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyBranchesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [municipalityId] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyBranchesGet(pageNumber?: number, pageSize?: number, search?: string, municipalityId?: string, entityId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyBranchDtoOrdinalPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyBranchesGet(pageNumber, pageSize, search, municipalityId, entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyBranchesIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyBranchesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyBranchesIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyBranchDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyBranchesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCompanyBranchCommand} [updateCompanyBranchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyBranchesIdPut(id: string, updateCompanyBranchCommand?: UpdateCompanyBranchCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyBranchesIdPut(id, updateCompanyBranchCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateCompanyBranchRequest} [createCompanyBranchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyBranchesPost(createCompanyBranchRequest?: CreateCompanyBranchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyBranchesPost(createCompanyBranchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CompanyBranchesApi - factory interface
 * @export
 */
export const CompanyBranchesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyBranchesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [municipalityId] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesGet(pageNumber?: number, pageSize?: number, search?: string, municipalityId?: string, entityId?: string, options?: any): AxiosPromise<CompanyBranchDtoOrdinalPaginatedList> {
            return localVarFp.apiCompanyBranchesGet(pageNumber, pageSize, search, municipalityId, entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiCompanyBranchesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesIdGet(id: string, options?: any): AxiosPromise<CompanyBranchDto> {
            return localVarFp.apiCompanyBranchesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCompanyBranchCommand} [updateCompanyBranchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesIdPut(id: string, updateCompanyBranchCommand?: UpdateCompanyBranchCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiCompanyBranchesIdPut(id, updateCompanyBranchCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateCompanyBranchRequest} [createCompanyBranchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyBranchesPost(createCompanyBranchRequest?: CreateCompanyBranchRequest, options?: any): AxiosPromise<string> {
            return localVarFp.apiCompanyBranchesPost(createCompanyBranchRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiCompanyBranchesGet operation in CompanyBranchesApi.
 * @export
 * @interface CompanyBranchesApiApiCompanyBranchesGetRequest
 */
export interface CompanyBranchesApiApiCompanyBranchesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof CompanyBranchesApiApiCompanyBranchesGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof CompanyBranchesApiApiCompanyBranchesGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof CompanyBranchesApiApiCompanyBranchesGet
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof CompanyBranchesApiApiCompanyBranchesGet
     */
    readonly municipalityId?: string

    /**
     * 
     * @type {string}
     * @memberof CompanyBranchesApiApiCompanyBranchesGet
     */
    readonly entityId?: string
}

/**
 * Request parameters for apiCompanyBranchesIdDelete operation in CompanyBranchesApi.
 * @export
 * @interface CompanyBranchesApiApiCompanyBranchesIdDeleteRequest
 */
export interface CompanyBranchesApiApiCompanyBranchesIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyBranchesApiApiCompanyBranchesIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiCompanyBranchesIdGet operation in CompanyBranchesApi.
 * @export
 * @interface CompanyBranchesApiApiCompanyBranchesIdGetRequest
 */
export interface CompanyBranchesApiApiCompanyBranchesIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyBranchesApiApiCompanyBranchesIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiCompanyBranchesIdPut operation in CompanyBranchesApi.
 * @export
 * @interface CompanyBranchesApiApiCompanyBranchesIdPutRequest
 */
export interface CompanyBranchesApiApiCompanyBranchesIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyBranchesApiApiCompanyBranchesIdPut
     */
    readonly id: string

    /**
     * 
     * @type {UpdateCompanyBranchCommand}
     * @memberof CompanyBranchesApiApiCompanyBranchesIdPut
     */
    readonly updateCompanyBranchCommand?: UpdateCompanyBranchCommand
}

/**
 * Request parameters for apiCompanyBranchesPost operation in CompanyBranchesApi.
 * @export
 * @interface CompanyBranchesApiApiCompanyBranchesPostRequest
 */
export interface CompanyBranchesApiApiCompanyBranchesPostRequest {
    /**
     * 
     * @type {CreateCompanyBranchRequest}
     * @memberof CompanyBranchesApiApiCompanyBranchesPost
     */
    readonly createCompanyBranchRequest?: CreateCompanyBranchRequest
}

/**
 * CompanyBranchesApi - object-oriented interface
 * @export
 * @class CompanyBranchesApi
 * @extends {BaseAPI}
 */
export class CompanyBranchesApi extends BaseAPI {
    /**
     * 
     * @param {CompanyBranchesApiApiCompanyBranchesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyBranchesApi
     */
    public apiCompanyBranchesGet(requestParameters: CompanyBranchesApiApiCompanyBranchesGetRequest = {}, options?: AxiosRequestConfig) {
        return CompanyBranchesApiFp(this.configuration).apiCompanyBranchesGet(requestParameters.pageNumber, requestParameters.pageSize, requestParameters.search, requestParameters.municipalityId, requestParameters.entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyBranchesApiApiCompanyBranchesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyBranchesApi
     */
    public apiCompanyBranchesIdDelete(requestParameters: CompanyBranchesApiApiCompanyBranchesIdDeleteRequest, options?: AxiosRequestConfig) {
        return CompanyBranchesApiFp(this.configuration).apiCompanyBranchesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyBranchesApiApiCompanyBranchesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyBranchesApi
     */
    public apiCompanyBranchesIdGet(requestParameters: CompanyBranchesApiApiCompanyBranchesIdGetRequest, options?: AxiosRequestConfig) {
        return CompanyBranchesApiFp(this.configuration).apiCompanyBranchesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyBranchesApiApiCompanyBranchesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyBranchesApi
     */
    public apiCompanyBranchesIdPut(requestParameters: CompanyBranchesApiApiCompanyBranchesIdPutRequest, options?: AxiosRequestConfig) {
        return CompanyBranchesApiFp(this.configuration).apiCompanyBranchesIdPut(requestParameters.id, requestParameters.updateCompanyBranchCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyBranchesApiApiCompanyBranchesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyBranchesApi
     */
    public apiCompanyBranchesPost(requestParameters: CompanyBranchesApiApiCompanyBranchesPostRequest = {}, options?: AxiosRequestConfig) {
        return CompanyBranchesApiFp(this.configuration).apiCompanyBranchesPost(requestParameters.createCompanyBranchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
